import { render, staticRenderFns } from "./sys-user.vue?vue&type=template&id=5adb45ff&scoped=true&"
import script from "./sys-user.vue?vue&type=script&lang=js&"
export * from "./sys-user.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5adb45ff",
  null
  
)

export default component.exports